// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_8WA","cls2":"CitationModal-cls2_zTm CitationModal-cls1_8WA"};